"use strict";
/**
 * Copyright © 2019 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var uiContext_1 = __importDefault(require("./uiContext")); // Function that generates a new array with an additional element


function addtoArray(myArr, myVal) {
  return myArr.concat(myVal);
} // Function that generates a new array after removing an element


function removefromArray(myArr, myVal) {
  var index = myArr.indexOf(myVal);

  if (index !== -1) {
    return __spreadArrays(myArr.slice(0, index), myArr.slice(index + 1));
  }

  return myArr;
} // A function to capitilize the first letter of the input string


function Capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
} // The Checkbox component
// On click add or remove the filter from activeFilter


function Checkbox(_a) {
  var type = _a.type,
      onToggle = _a.onToggle,
      isChecked = _a.isChecked,
      disabled = _a.disabled;
  var finalUI = react_1.useContext(uiContext_1.default);
  return react_1.default.createElement(finalUI.AccordionCheckboxWrapper, null, react_1.default.createElement(finalUI.AccordionCheckboxLabel, {
    htmlFor: type
  }, react_1.default.createElement(finalUI.AccordionCheckBox, {
    onChange: onToggle,
    checked: isChecked,
    disabled: disabled,
    id: type,
    name: type
  }), Capitalize(type)));
} // The Dropdown component
// On click render or do not render the checkbox (children)


function Dropdown(_a) {
  var children = _a.children,
      type = _a.type;

  var _b = react_1.useState(true),
      isOpen = _b[0],
      setIsOpen = _b[1];

  var finalUI = react_1.useContext(uiContext_1.default);
  return react_1.default.createElement(finalUI.AccordionWrapper, null, isOpen ? react_1.default.createElement(finalUI.AccordionItemWrapper, {
    onClick: function onClick() {
      return setIsOpen(false);
    }
  }, react_1.default.createElement(finalUI.AccordionIconContract, null), react_1.default.createElement(finalUI.AccordionLabel, null, Capitalize(type))) : react_1.default.createElement(finalUI.AccordionItemWrapper, {
    onClick: function onClick() {
      return setIsOpen(true);
    }
  }, react_1.default.createElement(finalUI.AccordionIconExpand, null), react_1.default.createElement(finalUI.AccordionLabel, null, Capitalize(type))), isOpen && react_1.default.createElement("div", null, children));
} // The wrapper that wraps the checkboxes and dropdown menus


var FilterWrapper = function FilterWrapper(props) {
  var allfilters = props.allfilters,
      filters = props.filters,
      activeFilter = props.activeFilter,
      setActiveFilters = props.setActiveFilters;
  var finalUI = react_1.useContext(uiContext_1.default);

  var isTermDisabled = function isTermDisabled(category, term) {
    return Object.entries(filters).length === 0 || !Object.keys(filters).includes(category) || !filters[category].includes(term);
  };

  var areAllTermsDisabled = function areAllTermsDisabled(category) {
    return allfilters[category].every(function (term) {
      return isTermDisabled(category, term);
    });
  };

  return react_1.default.createElement(finalUI.ComponentSelectorWrapper, null, Object.keys(allfilters).map(function (category) {
    if (allfilters[category].length > 0) {
      if (areAllTermsDisabled(category)) {
        return true;
      }

      return react_1.default.createElement(Dropdown, {
        type: category,
        key: category
      }, allfilters[category].map(function (value) {
        return react_1.default.createElement(Checkbox, {
          key: value,
          type: value,
          disabled: isTermDisabled(category, value),
          onToggle: function onToggle() {
            if (activeFilter.indexOf(value) !== -1) {
              setActiveFilters(removefromArray(activeFilter, value));
            } else {
              setActiveFilters(addtoArray(activeFilter, value));
            }
          },
          isChecked: activeFilter.indexOf(value) !== -1
        });
      }));
    }

    return true;
  }));
};

exports.default = FilterWrapper;